module.exports = "/images/side-users.svg?f45ccf5973c34112947845e51c3772c6";